import type { CreateTaskInput } from '@travel-planner/shared/schemas/tasks';
import type { TaskFormValues } from '../model/schema';
import { useCreateTask } from '@task-manager/entities/tasks';
import { toastMutation } from '@/shared/lib';
import { Modal, ModalHeader } from '@/shared/ui';
import { TaskForm } from './task-form';

type TaskCreateModalProps = {
  open: boolean;
  onClose: () => void;
  /** `'admin'` creates a template task (Collection field, no assignee/itinerary). */
  variant?: 'default' | 'admin';
};

export const TaskCreateModal = ({
  open,
  onClose,
  variant = 'default',
}: TaskCreateModalProps) => {
  const mutation = useCreateTask();

  const handleSubmit = (values: TaskFormValues) => {
    mutation.mutate(
      values as CreateTaskInput,
      toastMutation({ success: 'Task created' }, { onSuccess: onClose })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader title="Create Task" onClose={onClose} />
      <TaskForm
        onCancel={onClose}
        onSubmit={handleSubmit}
        submitLabel="Create"
        submitting={mutation.isPending}
        variant={variant}
      />
    </Modal>
  );
};
